<template>
  <WarrantList showFilter showFooter class="warrant-details-wrapper rk-section" />
</template>

<script>
import WarrantList from '@/components/warrants/WarrantList.vue'
export default {
  components: { WarrantList }
}
</script>

<style scoped>
.warrant-details-wrapper {
  padding: 0 15px;
  height: 100vh;
  background: var(--bg-color-2);
}
</style>
